// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2x0vR"};